import { useState } from "react";
import IconAddFolder from "../../components/icons/IconAddFolder";
import IconDelete from "../../components/icons/IconDelete";
import * as api from "./api";

export default function ConversationTagsButton({ conversation, onTagsChanged }) {
    const [isOpen, setIsOpen] = useState(false);
    const [newTag, setNewTag] = useState("");
    const [isGenerating, setIsGenerating] = useState(false);
    const [error, setError] = useState("");

    const tags = conversation?.tags || [];

    const saveTags = (names) => {
        return api
            .updateTags(conversation.id, names)
            .then(() => {
                setError("");
                return onTagsChanged();
            })
            .catch((err) => {
                console.error(err);
                setError("Не вдалося зберегти теги");
            });
    };

    const handleAddTag = () => {
        const trimmed = newTag.trim();
        if (!trimmed) return;
        const names = tags.map((tag) => tag.name).concat(trimmed);
        saveTags(names).then(() => setNewTag(""));
    };

    const handleRemoveTag = (tagId) => {
        const names = tags.filter((tag) => tag.id !== tagId).map((tag) => tag.name);
        saveTags(names);
    };

    const handleGenerate = () => {
        setIsGenerating(true);
        setError("");
        api.generateTags(conversation.id)
            .then((response) => {
                const generated = response.data || [];
                const merged = Array.from(new Set(tags.map((tag) => tag.name).concat(generated)));
                return saveTags(merged);
            })
            .catch((err) => {
                console.error(err);
                setError((err.response && err.response.data) || "Не вдалося згенерувати теги");
            })
            .finally(() => setIsGenerating(false));
    };

    return (
        <div className="functional-panelbutton toolbar-popup-anchor" onClick={() => setIsOpen((prev) => !prev)}>
            <IconAddFolder fillColor="icon-teel" style={{ height: 20, width: 20 }} />

            {isOpen ? (
                <div className="toolbar-popup" onClick={(e) => e.stopPropagation()}>
                    <p className="toolbar-popup-title">Теги</p>

                    {error ? <p className="toolbar-popup-error">{error}</p> : ""}

                    <ul className="toolbar-popup-list toolbar-popup-list-readonly">
                        {tags.map((tag) => (
                            <li key={tag.id}>
                                <span>{tag.name}</span>
                                <div className="toolbar-popup-list-delete" onClick={() => handleRemoveTag(tag.id)}>
                                    <IconDelete fillColor="icon-red" style={{ height: 16, width: 16 }} />
                                </div>
                            </li>
                        ))}
                        {tags.length === 0 ? <li>Ще немає тегів</li> : ""}
                    </ul>

                    <div className="toolbar-popup-add-row">
                        <input
                            value={newTag}
                            placeholder="Новий тег..."
                            onChange={(e) => setNewTag(e.target.value)}
                            onKeyDown={(e) => e.key === "Enter" && handleAddTag()}
                        />
                        <button type="button" onClick={handleAddTag}>
                            +
                        </button>
                    </div>

                    <button type="button" className="toolbar-popup-ai-button" disabled={isGenerating} onClick={handleGenerate}>
                        {isGenerating ? "Генерую... (до хвилини)" : "Згенерувати тегами AI"}
                    </button>
                </div>
            ) : (
                ""
            )}
        </div>
    );
}
